import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('grades')
export class Grades {

  @PrimaryGeneratedColumn("increment", { name: 'grade_id' })
  gradeId: number;

  @Column("char", {
    nullable: false,
    length: 50,
    name: "grade_name"
  })
  gradeName: string;

  @Column("char", {
    nullable: false,
    length: 50,
    name: "grade_min_count"
  })
  gradeMinCount: number;

  @Column("varchar", {
    nullable: false,
    length: 50,
    name: "grade_max_count"
  })
  gradeMaxCount: number;

  @Column("int", {
    nullable: false,
    name: "pack_count"
  })
  packCount: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;


  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
}
